import React, { useState, useEffect, useRef } from 'react';
import { Head } from '@inertiajs/react';
import FloatingMenu from '../../Components/FloatingMenu';
import MenuOverlay from '../../Components/MenuOverlay';
import ContactUs from '../../Components/ContactUs';
import Footer from '../../Components/Footer';
import SmoothScroll from '../../Components/SmoothScroll';

const Contact = () => {
    const scrollContainerRef = useRef(null);
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isScrolled, setIsScrolled] = useState(false);

    useEffect(() => {
        const wrapper = scrollContainerRef.current;
        if (!wrapper) return;

        const handleScroll = (e) => {
            if (e.target.scrollTop > 50) {
                setIsScrolled(true);
            } else {
                setIsScrolled(false);
            }
        };

        wrapper.addEventListener('scroll', handleScroll);
        return () => wrapper.removeEventListener('scroll', handleScroll);
    }, []);

    const isBrandBoxVisible = !isScrolled || isMenuOpen;

    return (
        <SmoothScroll ref={scrollContainerRef}>
            <Head>
                <title>Contact Us - Hollywood Royale Garden</title>
                <meta name="description" content="Get in touch with Hollywood Royale Garden. Schedule a tour, ask about availability, or learn more about our senior care services in Hollywood." />
                <meta property="og:title" content="Contact Us - Hollywood Royale Garden" />
                <meta property="og:description" content="We're here to help. Reach out to us for any inquiries about our assisted living community." />
                <meta property="og:image" content="/hrlogo2.png" />
            </Head>

            <FloatingMenu
                isVisible={true}
                isScrolled={isScrolled}
                toggleMenu={() => setIsMenuOpen(!isMenuOpen)}
                isMenuOpen={isMenuOpen}
            />

            <MenuOverlay isOpen={isMenuOpen} onClose={() => setIsMenuOpen(false)} />

            <div className={`brand-box2 ${isBrandBoxVisible ? 'visible' : 'hidden'}`} onClick={() => window.location.href = '/'}>
                <img src="/hrlogo2.png" alt="Hollywood Royale" className="brand-image" />
            </div>

            <div style={{ height: '100px' }}></div>

            <main>
                <ContactUs />
            </main>

            <Footer />
        </SmoothScroll>
    );
};

export default Contact;
